<template>
<div>
  <h4>Zmiana pakietu</h4>
  
  <form class="form-inline">
    <table class="table table-hover table-striped table-bordered">
      <tbody>
      <tr>
        <th>Email użytkownika</th>
        <td>{{ user.email }}</td>
      </tr>
      <tr>
        <th>Telefon użytkownika</th>
        <td>{{ user.phone }}</td>
      </tr>
      <tr>
        <th>Obecny pakiet</th>
        <td>
          {{ user.access.planDefinition.name }}
        </td>
      </tr>
      <tr>
        <th>Aktywność pakietu</th>
        <td>
          {{ user.access.startAt|date }} - {{ user.access.endAt|date }}
          <template v-if="user.access.isTrial">(okres testowy)</template>
        </td>
      </tr>
      <tr>
        <th>Zmień na pakiet</th>
        <td>
          <select v-model="newPlanDefinition" class="form-control">
            <option :value="null">-- wybierz pakiet --</option>
            <option :value="plan.id" v-for="plan in planDefinitions">{{ plan.name }}</option>
          </select>
        </td>
      </tr>
      <tr>
        <th>Czy okres testowy</th>
        <td>
          <checkbox-input v-model="trial" label="Okres testowy"></checkbox-input>
        </td>
      </tr>
      <tr>
        <th>Na okres</th>
        <td>
          <date-picker v-model="from"></date-picker>
          do
          <date-picker v-model="to"></date-picker>
        </td>
      </tr>
      <tr>
        <th colspan="2">
          <question-button
            @click="submit"
            question="Czy na pewno zmienić pakiet temu użytkownikowi"
            class="btn btn-primary"
          >
            Zmień pakiet
          </question-button>
        </th>
      </tr>
      </tbody>
    </table>
  </form>
</div>
</template>
<script>
import Api from './../api'
import Flash from './../Flash'
import QuestionButton from './QuestionButton.vue'
import DatePicker from './DatePicker.vue'
import CheckboxInput from './CheckboxInput.vue'

export default {
  props: {
    id: {type: [Number, String], required: true}
  },
  components: {
    QuestionButton,
    DatePicker,
    CheckboxInput
  },
  data () {
    return {
      planDefinitions: [],
      user: {
        access: {
          planDefinition: {}
        }
      },
      newPlanDefinition: null,
      from: '',
      to: '',
      trial: false
    }
  },
  methods: {
    fetchData () {
      Api.planDefinition.getList().then(this.onGetPlanDefinitionListSuccess)
      Api.user.getItem(this.id).then(this.onGetUserSuccess)
    },
    onGetPlanDefinitionListSuccess ({body}) {
      this.planDefinitions = body
    },
    onGetUserSuccess ({body}) {
      this.user = body
    },
    submit () {
      if (this.newPlanDefinition === null) {
        Flash.error('Nie wybrano nowego planu')
        return
      }
      Api.user.changePlanDefinition(this.id, this.newPlanDefinition, this.from, this.to, this.trial).then(this.onPlanChangeSuccess, this.onPlanChangeError)
    },
    onPlanChangeSuccess ({body}) {
      this.user = body
      Flash.success('Zmieniono plan użytkownikowi')
    },
    onPlanChangeError () {
      Flash.error('Wystąpił błąd podczas zmiany planu, skontaktuj się z administratorem')
    }
  },
  watch: {
    '$route': 'fetchData'
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// ChangePackage.vue?1a94eaac